import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Languages } from "lucide-react";

export default function LanguageToggle({ testId = "lang-toggle-btn" }) {
  const { lang, setLang } = useLang();
  return (
    <button
      data-testid={testId}
      onClick={() => setLang(lang === "vi" ? "en" : "vi")}
      className="h-10 px-3 rounded-full border border-border flex items-center gap-1.5 hover:bg-accent transition-colors text-sm"
      aria-label="Toggle language"
      title={lang === "vi" ? "Switch to English" : "Chuyển sang tiếng Việt"}
    >
      <Languages size={15} />
      <span className="font-semibold tabular-nums">{lang === "vi" ? "VI" : "EN"}</span>
    </button>
  );
}
